import { useQuery } from 'react-query';

import { useUser } from '~/features/user/hooks/use-user';
import { useClientRender } from '~/hooks/use-client-render';

import { getProgramRecommendations } from '../controllers/get-program-recommendations';
export function useProgramRecommendations() {
  const { jwt, userId } = useUser();
  const clientReady = useClientRender();
  const {
    data: programRecommendations,
    isLoading: programRecommendationsIsLoading,
    isFetched: programRecommendationsIsFetched,
  } = useQuery({
    queryKey: ['program-recommendations', userId],
    queryFn: () => {
      if (jwt) {
        return getProgramRecommendations(jwt);
      }
    },
    enabled: Boolean(jwt) && clientReady,
  });
  return {
    programRecommendations,
    programRecommendationsIsLoading,
    programRecommendationsIsFetched,
  };
}
